import React from 'react';

import {translations} from 'presentation/translations-new';

import {GuideFilterEnum} from 'main/analytics/gaTagsEnum';
import {OdontoGuideServicesTypeEnum, QueryParamsEnum} from 'presentation/constants';
import {useQueryParams} from 'presentation/pages/private';
import {textHandle} from 'presentation/utils/textHandle';
import {OdontoSpecialtiesInputProps} from './types';
import {SkeletonInput} from '../SkeletonInput';
import {AutocompleteSelect} from '../SearchDetails/AutocompleteSelect';

const {selectSpecialty} = translations['pt-br'].privateFlow.guideFlow;

export function OdontoSpecialtiesInput({
	odontoSpecialties,
	isLoading,
}: OdontoSpecialtiesInputProps) {
	const {SEARCH_PARAMS, setSearchParams} = useQueryParams();
	const {serviceType, specialtyCode} = SEARCH_PARAMS;

	const odontoSpecialtiesFiltered = odontoSpecialties?.filter(
		specialty => specialty?.cdEspecialidade && specialty?.dsEspecialidade,
	);

	if (isLoading) {
		return (
			<SkeletonInput label={translations['pt-br'].privateFlow.guideFlow.loadingSpecialties} />
		);
	}

	const shouldDisableInput =
		isLoading ||
		odontoSpecialties?.length === 0 ||
		!serviceType ||
		serviceType !== OdontoGuideServicesTypeEnum.OUTPATIENT;

	return (
		<AutocompleteSelect
			dataTagId={GuideFilterEnum.APLICOU_FILTRO_ESPECIALIDADE_ODONTO}
			key={serviceType}
			disabled={shouldDisableInput}
			customPlaceholder={selectSpecialty}
			value={specialtyCode || ''}
			onValueChange={val => {
				const selectedSpecialty = odontoSpecialtiesFiltered?.find(
					specialty => String(specialty?.cdEspecialidade) === val,
				);
				setSearchParams(prev => {
					prev.set(
						QueryParamsEnum.SPECIALTY_NAME,
						selectedSpecialty?.dsEspecialidade || '',
					);
					prev.set(
						QueryParamsEnum.SPECIALTY_CODE,
						String(selectedSpecialty?.cdEspecialidade || ''),
					);
					return prev;
				});
			}}
			options={odontoSpecialtiesFiltered ?? []}
			getOptionLabel={opt => textHandle(opt?.dsEspecialidade).capitalizeFirstLetter()}
			getOptionValue={opt => String(opt?.cdEspecialidade)}
		/>
	);
}
